import React, { useState, useEffect } from "react";
import "../Css/Sectiontwo.css";
import AdminContacts from "../../src/Component/Admincontact";
import Sponsors from "../../src/Component/Sponsors";

function Sectiontwo() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("https://api.gkaglobal.org/gkawebsite/comiteemember.php")
      .then((response) => response.json())
      .then((result) => {
        if (result.committee_members) {
          setData(result.committee_members);
        } else {
          console.error("Invalid data format", result);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <>
      <div className="container1">
        <h1 className="team">Team Committee Members</h1>
        <div className="container mt-5">
          <div className="row">
            {data.map((member, index) => (
              <div key={index} className="col-md-2 col-sm-4 col-6 mb-4">
                {/* Card Container */}
                <div
                  className="card"
                  style={{
                    position: "relative",
                    width: "100%",
                    border: "none",
                    borderRadius: "10px",
                  }}
                >
                  {/* Card Image */}
                  <img
                    src={`https://api.gkaglobal.org/${member.img}`}
                    className="card-img-top custom-card-img"
                    alt={member.name}
                  />

                  {/* Hover Info */}
                  <div className="card-info">
                    <h5>{member.name}</h5>
                    <p>
                      <strong>Position:</strong> {member.position}
                    </p>
                    <p>
                      <strong>Email:</strong> {member.email}
                    </p>
                    <p>
                      <strong>Location:</strong> {member.location}
                    </p>
                    <p>
                      <strong>Phone:</strong> {member.phone.home}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p className="p1">Hover mouse over the Pic to reveal a name</p>
        </div>
        <AdminContacts />
        <br />
      </div>
      <Sponsors />
    </>
  );
}

export default Sectiontwo;
